import { all, put, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../requests';

export function* getReportData(action) {
  try {
    const response = yield API.getReportData();
    yield put({
      type: ActionTypes.REPORT_GET_REPORT_DATA_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.REPORT_GET_REPORT_DATA_FAILURE,
    });
  }
}
export function* getCounselor(action) {
  try {
    const { payload } = action;
    const response = yield API.getCounselor(payload);
    yield put({
      type: ActionTypes.GET_COUNSELOR_SUCCESS,
      payload: JSON.parse(response.data.data),
    });
  } catch (error) {
    yield put({
      type: ActionTypes.HANDLE_ERRORS_REQUEST,
      successAction: action,
      error: error,
      failedAction: ActionTypes.GET_COUNSELOR_FAILURE,
    });
  }
}

export default function* root() {
  yield all([takeLatest(ActionTypes.GET_REPORT_DATA_REQUEST, getReportData)]);
  yield all([takeLatest(ActionTypes.GET_COUNSELOR_REQUEST, getCounselor)]);
}
